import React from "react";
import { FaGraduationCap } from "react-icons/fa";

const LevelTestCard = ({ title = "Quizz", percent = 32 }) => {
  const size = 100;
  const strokeWidth = 0;
  const radius = size / 2;
  const angle = (percent / 100) * 360;
  const radians = (angle * Math.PI) / 180;

  const x = radius + radius * Math.cos(radians - Math.PI / 2);
  const y = radius + radius * Math.sin(radians - Math.PI / 2);
  const largeArcFlag = angle > 180 ? 1 : 0;

  const pathData = `
    M ${radius},${radius}
    L ${radius},0
    A ${radius},${radius} 0 ${largeArcFlag} 1 ${x},${y}
    Z
  `;

  return (
    <div className="bg-white rounded-xl border p-4 min-w-[200px] flex-1 flex flex-col justify-between shadow-sm">
      {/* Icon + Titre */}
      <div>
        <FaGraduationCap className="text-gray-700 text-lg mb-2" />
        <h3 className="text-sm font-semibold text-gray-800">{title}</h3>
        <p className="text-sm text-gray-700">{percent}%</p>
      </div>

      {/* Secteur camembert */}
      <div className="flex justify-center mt-2">
        <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
          {/* Cercle de fond */}
          <circle cx={radius} cy={radius} r={radius} fill="#D1D5DB" />
          {/* Secteur de couleur */}
          <path d={pathData} fill="#159C92" />
        </svg>
      </div>
    </div>
  );
};

export default LevelTestCard;
